import { format } from "date-fns";

const isUserAdmin = ({ roles }) =>
  roles && roles.filter(({ role }) => role === "admin").length > 0;

const formatDate = (date) => format(date.toDate(), "d.M.yyyy - HH:mm:ss");

export { isUserAdmin, formatDate };
